var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lby-news-carousel"},[_c('el-carousel',{attrs:{"height":"50px","autoplay":true,"indicator-position":"none"}},_vm._l((_vm.data),function(item){return _c('el-carousel-item',{key:item.id},[_c('h3',{on:{"click":function($event){return _vm.goToPage(item.id)}}},[_vm._v(_vm._s(item.news))])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }